import * as React from "react"

export const StatPercentage = ({ percentage }: { percentage: number }) => {
  return (
    <div className="text-center font-family-paragraph font-weight-data text-heading-1 leading-heading-1">
      {percentage}%
    </div>
  )
}
